import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=148f1e72&"
import script from "./Standard.vue?vue&type=script&lang=js&"
export * from "./Standard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports